import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'

import { buildPathParams } from 'lib/utils/url'
import { convertAgesToString } from 'lib/paxes'
import { formatISO } from 'lib/dates'
import { getDatesAndPaxes } from 'src/effects/ModifyDates/selectors'
import { getVoucher } from 'src/comps/Voucher/selectors'
import { routes } from 'src/constants/routes'
import { VARIANTS, RESERVATION_NOT_OK } from './constants'

import ButtonSimple from 'src/comps/ButtonSimple'
import IconClose from 'client/icons/Close'

import { ConfirmationErrorBase, ButtonWrapper, Title, Subtitle, Content } from './styles'
import messages from './messages'

const ConfirmationError = ({ variant }) => {
  const intl = useIntl()
  const router = useRouter()

  const { hotelPreview } = useSelector(getVoucher)
  const datesAndPaxes = useSelector(getDatesAndPaxes)

  const [isLoading, setIsLoading] = useState(false)

  const childrenAges = convertAgesToString(datesAndPaxes?.childrenAges)
  const childrenParam = childrenAges.length > 0 ? { children: childrenAges } : null

  function redirectToHotelDetail() {
    setIsLoading(true)

    router.push({
      pathname: buildPathParams(routes.detail.pathname, {
        country: hotelPreview?.propertyCountry,
        slug: hotelPreview?.propertySlug,
        city: hotelPreview?.propertyCity,
      }),
      query: {
        adults: datesAndPaxes?.adults,
        checkin: formatISO(datesAndPaxes?.checkIn),
        checkout: formatISO(datesAndPaxes?.checkOut),
        ...childrenParam,
      },
    })
  }

  return (
    <ConfirmationErrorBase>
      <Content>
        <Title>
          <IconClose size={24} />
          <FormattedMessage
            {...messages[variant === RESERVATION_NOT_OK ? 'reservationNotOk' : 'changeDatesNotOk']}
            tagName="span"
          />
        </Title>

        <Subtitle>
          <FormattedMessage
            {...messages[variant === RESERVATION_NOT_OK ? 'reservationNextStep' : 'dontWorry']}
          />
        </Subtitle>
      </Content>

      {variant === RESERVATION_NOT_OK && (
        <ButtonWrapper>
          <ButtonSimple
            onClick={redirectToHotelDetail}
            variant="primary"
            dataTestId="book-btn-error"
            text={intl.formatMessage(messages.book)}
            fullWidth
            isLoading={isLoading}
          />
        </ButtonWrapper>
      )}
    </ConfirmationErrorBase>
  )
}

ConfirmationError.propTypes = {
  variant: PropTypes.oneOf(VARIANTS),
}

export default ConfirmationError
